import * as React from 'react';
import * as classnames from 'classnames/bind';
import {InputProps} from '@mintdata-wsp/wsp/ui/components/forms/Input';
import {TextRun} from '@mintdata-wsp/wsp/ui/components/text/TextRun';

const styles = require('./InputHelp.less');
const cx = classnames.bind(styles);

export interface InputHelpProps extends InputProps
{
    className?:string;
    label?:string;
}

export class InputHelp extends React.Component<InputHelpProps, any>
{
    render()
    {
        let {label, className} = this.props;

        return  (
            <div className={cx('inputHelp', className)}>
                {label ? label : this.props.children ? this.props.children : null}
            </div>
        );
    }
}
